<div class="toggle-switch-wrapper" [class.no-label]="!label?.trim()">
    <label class="toggle-label">
        {{ label }}
        @if (required) {
<span class="text-danger">*</span>
}
    </label>

    <div class="switch-container" [class.disabled]="isDisabled" (click)="toggle()" [attr.data-id]="dataId">
        <div class="switch-track" [class.on]="control?.value">
            <div class="switch-thumb"></div>
        </div>
    </div>

    @if (control.invalid && (control.dirty || control.touched)) {
<div class="text-danger">
        @if (control.errors?.required) {
<div>This field is required.</div>
}
    </div>
}
</div>